




















































































import { Component, Vue } from 'vue-property-decorator'
import { Helper } from '@/helpers/Helper'
import PageHead from '@/components/PageHead.vue'
import { Notify } from '@/helpers/Notify'
import { Api } from '@/fetch/Api'

@Component({
  components: {
    PageHead,
  },
})

export default class EmailSystem extends Vue {
  pageTitle = 'New Email System'
  callInProgress = false
  domainEmails = false
  emailAddress = null
  password = null
  password_confirmation = null

  get Helper() {
    return Helper
  }

  mounted() {
    this.fetchDomainEmails()
  }

  public async fetchDomainEmails() {
    this.callInProgress = true
    try {
      const domainEmailsResponse = await Api.fetchDomainEmails(Helper.getCurrentDomain())
      this.domainEmails = domainEmailsResponse.domainEmails
      this.callInProgress = false
    } catch (e) {
      this.callInProgress = false
      Notify.create({
        type: 'error',
        title: 'Something went wrong...',
        text: e,
      })
    }
  }

  public async getLoginUrl(loginEmail) {
    try {
      const loginLinkResponse = await Api.getLoginLink(Helper.getCurrentDomain(), loginEmail)
      if (loginLinkResponse.emailLoginLink) {
        window.open(loginLinkResponse.emailLoginLink, '_blank')
      } else {
        Notify.create({
          type: 'error',
          title: 'Something went wrong...',
          text: 'Could Not log you in the ' + loginEmail + ' email account',
        })
      }
    } catch (e) {
      this.callInProgress = false
      Notify.create({
        type: 'error',
        title: 'Something went wrong...',
        text: e,
      })
    }
  }

  public async createNewMailBox() {
    try {
      const createMailBoxResponse = await Api.createNewMailBox(Helper.getCurrentDomain(), this.emailAddress, this.password, this.password_confirmation)
      if (createMailBoxResponse.error === 1) {
        Notify.create({
          type: 'error',
          title: 'Something went wrong...',
          text: createMailBoxResponse.message,
        })
      } else {
        this.fetchDomainEmails()
        Notify.create({
          type: 'success',
          title: createMailBoxResponse.message,
          text: createMailBoxResponse.message,
        })
        this.$bvModal.hide('modal-create-new-mailbox')
      }
    } catch (e) {
      this.callInProgress = false
      Notify.create({
        type: 'error',
        title: 'Something went wrong...',
        text: e,
      })
    }
  }
}
